"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var lodash_1 = require("lodash");
var listing_1 = require("./listing");
var listing_card_1 = require("./listing_card");
var tiles_1 = require("@reverbdotcom/commons/dist/components/tiles");
var tracker_1 = require("@reverbdotcom/commons/dist/tracker");
var GridView = /** @class */ (function (_super) {
    tslib_1.__extends(GridView, _super);
    function GridView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GridView.prototype.componentDidMount = function () {
        this.trackView();
    };
    GridView.prototype.componentDidUpdate = function (prevProps) {
        var listingIds = this.listingIds(this.props.listings);
        var prevListingIds = this.listingIds(prevProps.listings);
        if (lodash_1.isEqual(listingIds, prevListingIds)) {
            return;
        }
        this.trackView();
    };
    GridView.prototype.listingIds = function (listings) {
        if (!listings) {
            return [];
        }
        return listings.map(function (l) { return l.id; });
    };
    GridView.prototype.trackView = function () {
        if (this.props.listings.length === 0) {
            return;
        }
        tracker_1.trackView({
            componentName: this.props.trackName,
            type: tracker_1.LISTING_TYPE,
            ids: this.listingIds(this.props.listings),
            context: this.props.trackContext,
        });
    };
    GridView.prototype.listingViews = function () {
        var _this = this;
        return this.props.listings.map(function (listingJson, index) {
            var listing = new listing_1.default(listingJson);
            return (React.createElement(listing_card_1.default, { listing: listing, key: listing.id, trackName: _this.props.trackName, trackContext: _this.props.trackContext, position: index + 1 }));
        });
    };
    GridView.prototype.renderActions = function () {
        if (!this.props.actions) {
            return null;
        }
        return (React.createElement("div", { className: "listing-grid__heading__actions" }, this.props.actions));
    };
    GridView.prototype.renderHeading = function () {
        if (!this.props.heading) {
            return null;
        }
        return (React.createElement("div", { className: "listing-grid__heading" },
            React.createElement("h1", { className: "listing-grid__heading__text" }, this.props.heading),
            this.renderActions()));
    };
    GridView.prototype.renderPagination = function () {
        if (!this.props.pagination) {
            return null;
        }
        return (React.createElement("div", { className: "listing-grid__pagination" }, this.props.pagination));
    };
    GridView.prototype.render = function () {
        return (React.createElement("section", { className: "listing-grid" },
            this.renderHeading(),
            React.createElement(tiles_1.default, { fourWideMax: true }, this.listingViews()),
            this.renderPagination(),
            this.props.children));
    };
    GridView.defaultProps = {
        showSearchFooter: false,
        pagination: false,
        heading: false,
        trackName: 'GridView',
    };
    return GridView;
}(React.Component));
exports.default = GridView;
//# sourceMappingURL=grid_view.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/grid_view.js
// module id = Hpq/
// module chunks = 20 21